module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "n-title"
  }, [_vm._v("更新公告")]), _vm._v(" "), _c('iframe', {
    staticStyle: {
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "src": "static/html/release-notes.2.5.5.html"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "n-footer"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.goHome()
      }
    }
  }, [_vm._v("进入系统")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-16f6c968!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/service/notice/notice.vue
// module id = 955
// module chunks = 2